export default (params) => ({
  trigger: {
    name: 'account.open_account',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'header',
          'bottom_navigation',
        ],
      },
    },
    event: {
      name: 'open_menu',
      params: {
        content: 'account_overview',
      },
    },
  },
});
